<ng-container *ngIf="visible">
    <div *ngFor="let msg of messages; index as i;" appTopLayer class="ab-container {{msg.theme}}"
         [ngStyle]="{'top': msg.top, 'z-index': 9999 - i}">
        <span class="ab-time">{{ msg.time }} <span *ngIf="msg.reference">- {{ msg.reference }}</span></span>
        <span *ngIf="msg.copied" class="ab-copied">Copied!</span>
        <i class="bhi-times icon-button ab-close-icon" (click)="hide(msg.id)"></i>
        <h2 class="ab-messagearea" (dblclick)="copyToClipboard(msg)">{{ msg.message }}</h2>
        <p class="ab-detailsarea" (click)="onDetailsClick($event, msg)" (dblclick)="copyToClipboard(msg)" [innerHTML]="msg.details"></p>
        <i class="materials-icons material-symbols-outlined notranslate material-icons-outlined ab-icon-background">
            <ng-container *ngIf="msg.theme === 'info'">info</ng-container>
            <ng-container *ngIf="msg.theme === 'error'">error</ng-container>
            <ng-container *ngIf="msg.theme === 'success'">check_circle</ng-container>
            <ng-container *ngIf="msg.theme === 'warning'">warning</ng-container>
        </i>
    </div>
</ng-container>
